import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import SkeletonLoading from '@/components/SkeletonLoading'
import { Promised } from 'vue-promised'
import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import localeData from 'dayjs/plugin/localeData'

import './plugins'

dayjs.extend(localizedFormat)
dayjs.extend(customParseFormat)
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(localeData)

Vue.config.productionTip = false
Vue.component('SkeletonLoading', SkeletonLoading)
Vue.component('Promised', Promised)

const appEnv = process.env.NODE_ENV

window.OneSignal = window.OneSignal || []

Vue.prototype.$initOneSignal = {
  appId: process.env.VUE_APP_ONESIGNAL,
  autoResubscribe: true,
  allowLocalhostAsSecureOrigin: appEnv === 'localhost',
  notificationClickHandlerMatch: 'origin',
  notifyButton: {
    enable: true,
    showCredit: false,
    colors: {
      'circle.background': '#00adcd',
      'circle.foreground': 'white',
      'badge.background': '#00adcd',
      'badge.foreground': 'white',
      'badge.bordercolor': '#00adcd',
      'pulse.color': 'white',
      'dialog.button.background.hovering': '#00adcd',
      'dialog.button.background.active': '#00adcd',
      'dialog.button.background': '#00adcd',
      'dialog.button.foreground': 'white'
    },
    displayPredicate: true
  }
}

const init = async () => {
  try {
    await store.dispatch('auth/init')
    await store.dispatch('getCurrentGroup')
  } catch (e) {}

  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}

init()
